import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawKeukenblokGreenModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Keukenblok");

		this.name = "keukenblok-green";
		this.icon = svg_keukenblok_green;
		this.svgTextIndex = 5;
	}
}

window.customElements.define("inspx-draw-keukenblok-green-module", DrawKeukenblokGreenModule);

const svg_keukenblok_green = (text) => html`
<svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="25.703865mm" height="11.656082mm" viewBox="0 0 25.703865 11.656082">
    <defs id="defs2432" />
    <g transform="translate(-60.475449,-124.10648)">
        <g id="g5245" transform="matrix(0.26458333,0,0,0.26458333,-105.25469,82.38745)">
            <rect ry="0" y="158.16074" x="626.86414" height="43.089481" width="96.183464" id="rect6156-1" style="fill:#00ff00;fill-opacity:0.98843934;stroke:#021801;stroke-width:0.96500343;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            />
            <rect ry="4.6636977" y="167.04977" x="646.23297" height="17.100225" width="28.805494" id="rect6158-4" style="fill:#00ff00;fill-opacity:0.98843934;stroke:#021801;stroke-width:1.07466543;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            />
            <path id="path6188-2" d="m 694.24208,167.04977 h 19.20366" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <path id="path6190-3" d="m 694.24208,175.59988 h 19.20366" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <path id="path6192-2" d="m 694.24208,184.14999 h 19.20366" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <text transform="scale(0.7599368,1.3158989)" id="text6200-2" y="149.80807" x="838.14294" style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:'Arial Bold';text-align:start;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
                xml:space="preserve">
                <tspan y="149.80807" x="838.14294" id="tspan6202-1" style="font-size:12.63503933px;line-height:1.25;stroke-width:1.06666672">${text}</tspan>
            </text>
        </g>
    </g>
</svg>`;
